module.exports = __webpack_public_path__ + "img/logo-light.c2b32a48.png";